import React, { createContext, useContext, useState } from 'react'

interface LicenseTableContextType{
  selectedLicense: String;
  setSelectedLicense: React.Dispatch<React.SetStateAction<string>>
  selectedLicensePreset: String,
  setSelectedLicensePreset: React.Dispatch<React.SetStateAction<string>>,
  selectedModal: String;
  setSelectedModal: React.Dispatch<React.SetStateAction<string>>
  useHeader: {};
  setUseHeader: React.Dispatch<React.SetStateAction<{}>>
  refetchLicenses: null;
  setRefetchLicenses: React.Dispatch<React.SetStateAction<null>>
  refetchLicensePresets: null;
  setRefetchLicensePresets: React.Dispatch<React.SetStateAction<null>>
  selectedBulkLicense: String;
  setSelectedBulkLicense: React.Dispatch<React.SetStateAction<string>>
}

const LicenseTableContext = createContext<LicenseTableContextType | null>(null)

export const LicenseTableProvider: React.FC = ({ children }) => {
  const [ selectedLicense, setSelectedLicense ] = useState('')
  const [ selectedLicensePreset, setSelectedLicensePreset ] = useState('')
  const [ selectedModal, setSelectedModal ] = useState('')
  const [ useHeader, setUseHeader ] = useState({})
  const [ refetchLicenses, setRefetchLicenses ] = useState(null)
  const [ refetchLicensePresets, setRefetchLicensePresets ] = useState(null)
  const [ selectedBulkLicense, setSelectedBulkLicense ] = useState('')

  return(
    <LicenseTableContext.Provider value={{
      selectedLicense,
      setSelectedLicense,
      selectedLicensePreset,
      setSelectedLicensePreset,
      selectedModal,
      setSelectedModal,
      useHeader,
      setUseHeader,
      refetchLicenses, 
      setRefetchLicenses,
      refetchLicensePresets, 
      setRefetchLicensePresets,
      selectedBulkLicense,
      setSelectedBulkLicense
    }}>
      { children }
    </LicenseTableContext.Provider>
  )
}

const useLicenseTable = (): LicenseTableContextType => {
  const context = useContext(LicenseTableContext)
  if( !context ){
    throw new Error('useLicenseTable must be used within a LicenseTableProvider');
  }
  return context
}

export default useLicenseTable
